// extracted by mini-css-extract-plugin
module.exports = {"root":"CopyConfirmationTooltip__root--2-yqJ","icon":"CopyConfirmationTooltip__icon--1wi4I"};